module.exports = __webpack_public_path__ + "img/8.105475b5.jpg";